module.exports = __webpack_public_path__ + "static/media/synergy.35fb0526.png";